export const list = {
    "34": {
        "title": "Maneki-neko",
        "url": "https://jenniferdewalt.com/lucky_cat.html",
    },
    "33": {
        "title": "Random Word Generator",
        "url": "https://jenniferdewalt.com/random_word.html",
    },
    "32": {
        "title": "Particle Waves",
        "url": "https://jenniferdewalt.com/particle_waves.html",
    },
    "31": {
        "title": "Endless Throbbers",
        "url": "https://jenniferdewalt.com/endless_throbbers.html",
    },
    "30": {
        "title": "Silly Kitty",
        "url": "https://jenniferdewalt.com/silly_kitty.html",
    },
    "29": {
        "title": "Magic 8 Ball",
        "url": "https://jenniferdewalt.com/magic_8.html",
    },
    "28": {
        "title": "The Click Challenge",
        "url": "https://jenniferdewalt.com/click_challenge.html",
    },
    "27": {
        "title": "Rain Maker",
        "url": "https://jenniferdewalt.com/rain_maker.html",
    },
    "26": {
        "title": "Simon",
        "url": "https://jenniferdewalt.com/simon.html",
    },
    "25": {
        "title": "SCRAMBLED!",
        "url": "https://jenniferdewalt.com/scrambled.html",
    },
    "24": {
        "title": "What is Your Email's Impact?",
        "url": "https://jenniferdewalt.com/email_impact.html",
    },
    "23": {
        "title": "Stopwatch",
        "url": "https://jenniferdewalt.com/stopwatch.html",
    },
    "22": {
        "title": "Keep It Straight",
        "url": "https://jenniferdewalt.com/keep_it_straight.html",
    },
    "21": {
        "title": "Teleprompter",
        "url": "https://jenniferdewalt.com/teleprompter.html",
    },
    "20": {
        "title": "Smushing Fireflies",
        "url": "https://jenniferdewalt.com/smushing_fireflies.html",
    },
    "19": {
        "title": "How Much of an SF Hipster are You?",
        "url": "https://jenniferdewalt.com/hipster_quiz.html",
    },
    "18": {
        "title": "Building Blocks",
        "url": "https://jenniferdewalt.com/building_blocks.html",
    },
    "17": {
        "title": "Party Time?",
        "url": "https://jenniferdewalt.com/party_time.html",
    },
    "16": {
        "title": "Caterpillar",
        "url": "https://jenniferdewalt.com/caterpillar.html",
    },
    "15": {
        "title": "Dropping Boxes",
        "url": "https://jenniferdewalt.com/dropping_boxes.html",
    },
    "14": {
        "title": "Tough Love",
        "url": "https://jenniferdewalt.com/tough_love.html",
    },
    "13": {
        "title": "Rock Paper Scissors",
        "url": "https://jenniferdewalt.com/rock_paper_scissors.html",
    },
    "12": {
        "title": "Dice Roller",
        "url": "https://jenniferdewalt.com/dice_roller.html",
    },
    "11": {
        "title": "Color Clock",
        "url": "https://jenniferdewalt.com/color_clock.html",
    },
    "10": {
        "title": "Sushi Jiggler",
        "url": "https://jenniferdewalt.com/sushi_jiggler.html",
    },
    "9": {
        "title": "Bouncing Ball",
        "url": "https://jenniferdewalt.com/bouncing_ball.html",
    },
    "8": {
        "title": "More Drop Shadow!",
        "url": "https://jenniferdewalt.com/more_drop_shadow.html",
    },
    "7": {
        "title": "Technicolor Boxes",
        "url": "https://jenniferdewalt.com/technicolor_boxes.html",
    },
    "6": {
        "title": "Day Tracker",
        "url": "https://jenniferdewalt.com/day_tracker.html",
    },
    "5": {
        "title": "Secret Message",
        "url": "https://jenniferdewalt.com/secret_message.html",
    },
    "4": {
        "title": "Paint a Mondrian",
        "url": "https://jenniferdewalt.com/mondrian.html"
    },
    "3": {
        "title": "Get a Random Color Background",
        "url": "https://jenniferdewalt.com/random_background.html"
    },
    "2": {
        "title": "Make a Deal!",
        "url": "https://jenniferdewalt.com/make_a_deal.html"
    },
    "1": {
        "title": "Homepage",
        "url": "https://jenniferdewalt.com/index.html"
    }
}